import { ProductClickedEventParams } from "../events/product/ProductClickedEvent";
import { ProductAddedToCartEventParams } from "../events/product/ProductAddedToCartEvent";
import { getCommonParams } from "./CommonParams";
import { mapProductTrackingData } from "./ProductObjectMapper";
import { ProductViewedEventParams } from "../events/product/ProductViewedEvent";

export const createProductClickedEventParams = (
    productObj: any,
    inventoryStatus?: string | null
): ProductClickedEventParams => {
    return {
        ...getCommonParams(),
        BUSINESS_VERTICAL: 'grocery',
        EVENT_CATEGORY: 'grocery',
        PRODUCTS: [mapProductTrackingData(productObj, inventoryStatus)],
    }
}

export const createProductAddedToCartEventParams = (
    productObj: any,
    inventoryStatus?: string | null,
    quantity?: number | null
): ProductAddedToCartEventParams => {
    return {
        ...getCommonParams(),
        BUSINESS_VERTICAL: 'grocery',
        EVENT_CATEGORY: 'grocery',
        FULFILMENT_CHANNEL: 'online',
        CHECKOUT_FLOW: 'e-commerce',
        PRODUCTS: [mapProductTrackingData(productObj, inventoryStatus, quantity ?? 1)],
    }
}

export const createProductViewedEventParams = (
    products: []
): ProductViewedEventParams => {
    return {
        ...getCommonParams(),
        BUSINESS_VERTICAL: 'grocery',
        PRODUCTS: products,
    }
}